import React from 'react';
import { Leaf, FlaskConical, Heart, Award, CheckCircle2 } from 'lucide-react';
export function VitalityPage() {
  return <div className="bg-white min-h-screen pb-20" data-id="element-679">
      {/* Page Header */}
      <div className="bg-gray-50 border-b border-gray-200 py-16 px-4 sm:px-6 lg:px-8" data-id="element-680">
        <div className="max-w-4xl mx-auto text-center" data-id="element-681">
          <div className="flex items-center justify-center gap-3 mb-4" data-id="element-682">
            <Heart className="w-10 h-10 text-[#0e7be1]" data-id="element-683" />
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900" data-id="element-684">
              Vitality
            </h1>
          </div>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto mt-4" data-id="element-685">
            Based in Nature, Backed by Science
          </p>
          <div className="w-24 h-1 bg-[#0e7be1] mx-auto rounded-full mt-8" data-id="element-686"></div>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 space-y-16" data-id="element-687">
        {/* Intro Section */}
        <section data-id="element-688">
          <div className="prose prose-lg text-gray-600 max-w-none" data-id="element-689">
            <p className="text-xl font-medium text-gray-900 leading-relaxed mb-6" data-id="element-690">
              At GNLD, we believe the right decisions about nutrition—deciding
              what to put into your body and what to keep out of your body—are
              among the most important decisions of your life.
            </p>
            <p data-id="element-691">
              These are the same decisions we make everyday for ourselves and
              our families, and they are the same decisions behind every GNLD
              product. And when it comes to our health, our families, and our
              products, there's simply not room for compromise.
            </p>
          </div>
        </section>

        {/* Question Section */}
        <section className="bg-blue-50 rounded-2xl p-8 md:p-10 border border-blue-100" data-id="element-692">
          <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center gap-3" data-id="element-693">
            <CheckCircle2 className="w-6 h-6 text-[#0e7be1]" data-id="element-694" />
            Ask yourself this simple question: "What's important to me?"
          </h2>
          <div className="space-y-6" data-id="element-695">
            <div className="flex gap-4" data-id="element-696">
              <div className="flex-shrink-0 mt-1" data-id="element-697">
                <Leaf className="w-6 h-6 text-[#1a8f3c]" data-id="element-698" />
              </div>
              <p className="text-lg text-gray-700" data-id="element-699">
                Is it important to you that the nutritional supplements you
                choose are made from ingredients Mother Nature intended for your
                body, ingredients proven safe and effective by centuries of
                human consumption?
              </p>
            </div>
            <div className="flex gap-4" data-id="element-700">
              <div className="flex-shrink-0 mt-1" data-id="element-701">
                <FlaskConical className="w-6 h-6 text-[#0e7be1]" data-id="element-702" />
              </div>
              <p className="text-lg text-gray-700" data-id="element-703">
                Is it important to you that these supplements are based on real,
                valid science backed by the industry's leader in advanced
                nutrition?
              </p>
            </div>
          </div>
        </section>

        {/* Science & Nature Section */}
        <section data-id="element-704">
          <div className="flex items-center gap-3 mb-6" data-id="element-705">
            <Award className="w-8 h-8 text-[#0e7be1]" data-id="element-706" />
            <h2 className="text-3xl font-bold text-gray-900" data-id="element-707">
              Based in Nature, Backed by Science
            </h2>
          </div>
          <div className="prose prose-lg text-gray-600 max-w-none" data-id="element-708">
            <p className="mb-6" data-id="element-709">
              All GNLD products are Based in Nature, Backed by Science. Members
              of our Scientific Advisory Board, all recognized worldwide as
              leading edge scientists, strictly adhere to Nature's Blueprint as
              they research, develop, and maintain our world-class products.
            </p>
            <p data-id="element-710">
              Our unique and enduring commitment to product excellence has
              attracted the attention of researchers from the United States
              Department of Agriculture, Centers for Disease Control, major
              universities, and respected scientific institutions around the
              world.
            </p>
            <p className="mt-6 p-6 bg-gray-50 border-l-4 border-[#0e7be1] italic text-gray-700 rounded-r-lg" data-id="element-711">
              It has caused GNLD product science to become a frequent topic in
              major scientific journals and allowed us to form lasting
              partnerships for the continued expansion of scientific knowledge
              about nutrition and health with such prestigious organizations as
              the Stanford University Health Library.
            </p>
          </div>
        </section>
      </div>
    </div>;
}